import { Component } from "@angular/core";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";

@Component({
    selector: "app-half-price",
    imports: [AppLayoutComponent],
    templateUrl: "./half-price.component.html",
    styleUrl: "./half-price.component.scss"
})
export class HalfPriceComponent {}
